import { render, staticRenderFns } from "./SecaoProblema.vue?vue&type=template&id=5fd37b95&scoped=true"
import script from "./SecaoProblema.vue?vue&type=script&lang=js"
export * from "./SecaoProblema.vue?vue&type=script&lang=js"
import style0 from "./SecaoProblema.vue?vue&type=style&index=0&id=5fd37b95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd37b95",
  null
  
)

export default component.exports